/**
 * Plays the exam "time running out" alert once (caller controls when).
 *
 * Uses a single Audio instance to avoid repeated allocations.
 */

const SOUND_URL = '/sounds/exam-timer-warning.mp3';

let audioInstance: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
  if (!audioInstance) {
    audioInstance = new Audio(SOUND_URL);
    audioInstance.volume = 0.7;
  }
  return audioInstance;
}

/**
 * Plays the timer warning chime. Safe to call from effects; failures are ignored
 * (e.g. autoplay policy before user gesture).
 */
export function playExamTimerWarningSound(): void {
  const audio = getAudio();
  audio.currentTime = 0;
  void audio.play().catch(() => {
    // Autoplay blocked or decode error — ignore
  });
}
